import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-table-down",
  "use": "icon-table-down-usage",
  "viewBox": "0 0 11 6",
  "content": "<symbol viewBox=\"0 0 11 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-down\">\n<path d=\"M9.76172 0.499512L5.26172 4.99951L0.761719 0.499512\" stroke=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol